export function getCategoryIds(categoryIds) {
    const finalCategoryIds = categoryIds.map((item) => item?.id);
    return finalCategoryIds.join(',');
}
